var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('Head'),_c('banner',{attrs:{"banner":_vm.slidePic,"slide":_vm.slide}}),_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"container"},[_c('Content',{attrs:{"pagecontent":_vm.thispage.items}})],1)]),_c('Foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }